<template>
  <WebPanelPage class="ui-modals-route" title="Modals">
    <div class="flex mb5">
      <BreadcrumbNav
        :items="[
          { name: 'UI Components', routerLink: { name: 'ui-index' } },
          { name: 'Modals' },
        ]"
      ></BreadcrumbNav>
    </div>
    <div>
      <ul>
        <li class="mb3">
          <UIButton ghost @click="openDefaultModal()">Default Modal</UIButton>
        </li>
        <li class="mb3">
          <UIButton ghost @click="openDefaultModalWithTitle()">Default Modal with title</UIButton>
        </li>
        <li class="mb3">
          <UIButton ghost @click="confirmDelete()">Default Confirm</UIButton>
        </li>
        <li class="mb3">
          <UIButton ghost @click="confirmDeleteWithIcon()">Confirm with icon</UIButton>
        </li>
        <li class="mb3">
          <UIButton ghost @click="confirmDeleteWithRender()">Confirm with render function</UIButton>
        </li>
        <li class="mb3">
          <UIButton ghost @click="openModal()">Custom</UIButton>
        </li>
      </ul>
    </div>
  </WebPanelPage>
</template>
<script>
import BreadcrumbNav from '@sbvr/common/legacy-shared/components/BreadcrumbNav';
import WebPanelPage from '@sbvr/web-panel/WebPanelPage';
import useModalService from '@sbvr/web-panel/modal';
import ExampleModal from '@sbvr/web-panel/modal/modals/ExampleModal';
import DefaultModal from '@sbvr/web-panel/modal/modals/DefaultModal';
import UIButton from '@sbvr/ui/UIButton';

export default {
  name: 'UIModalsRoute',
  components: {
    WebPanelPage,
    BreadcrumbNav,
    UIButton,
  },
  setup (props) {
    const { confirm, modal } = useModalService();
    const openDefaultModal = function () {
      modal(DefaultModal, {
        props: {
          message: 'Hello',
        },
        on: {
          closed () {
            alert('closed');
          },
        },
      });
    };
    const openDefaultModalWithTitle = function () {
      modal(DefaultModal, {
        props: {
          title: 'Default Modal With Title',
          message: 'Hello',
        },
        on: {
          closed () {
            alert('closed');
          },
        },
      });
    };
    const openModal = function () {
      modal(ExampleModal, {
        on: {
          closed () {
            alert('closed');
          },
        },
      });
    };
    async function confirmDelete () {
      const { confirmed } = await confirm({ message: 'Are you sure you want to delete ?' });
      if (confirmed) alert('deleted');
    };
    async function confirmDeleteWithIcon () {
      const { confirmed } = await confirm({ message: 'Are you sure you want to delete ?', icon: 'trash' });
      if (confirmed) alert('deleted');
    };
    async function confirmDeleteWithRender () {
      confirm({
        render (h) {
          return h(UIButton, { props: { warning: true, icon: 'alert-triangle-fill' } }, 'this button comes from a render function');
        },
      });
    };
    return {
      openModal,
      openDefaultModal,
      openDefaultModalWithTitle,
      confirmDelete,
      confirmDeleteWithIcon,
      confirmDeleteWithRender,
    };
  },
};
</script>

<style lang="postcss" scoped>
.devices-show-route {
  @apply --container;
  padding-top: var(--spacingMd);
}
</style>
